import { render } from "./SearchBoxField.vue?vue&type=template&id=4c0abd8f&scoped=true"
import script from "./SearchBoxField.vue?vue&type=script&lang=js"
export * from "./SearchBoxField.vue?vue&type=script&lang=js"

import "./SearchBoxField.vue?vue&type=style&index=0&id=4c0abd8f&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0abd8f"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
